import { HIDE_PRODUCT_CONNECTED_HOME } from '@constants/base';

const ICON_BENEFITS_REFERENCES = {
  homeCheckup: `/_nextassets_/icons/home-checkup.svg`,
  discounts: `/_nextassets_/icons/inhome-discounts.svg`,
  unlimitedSupport: `/_nextassets_/icons/online-support.svg`,
  support: `/_nextassets_/icons/tech-specialist.svg`,
  antivirus: `/_nextassets_/icons/premium-antivirus.svg`,
  password: `/_nextassets_/icons/premium-password.svg`,
  productDiscount: `/_nextassets_/icons/product-discount.svg`,
  device: '/_nextassets_/images/device-mgmt.svg',
  benefitNoPlatformFees: '/_nextassets_/icons/benefit-no-platform-fees.svg',
  benefitSupportHotline: '/_nextassets_/icons/members-hotline.svg',
  benefitWaivedCancellationFees: '/_nextassets_/icons/benefit-waived-cancellation-fees.svg',
};

export const PLAN_BENEFITS_IDS = {
  ONLINE: 'online',
  CHECKUP: 'checkup',
  ANTIVIRUS: 'antivirus',
  PASSWORD: 'password',
  IN_HOME: 'inHome',
  HOME_TECH: 'homeTech',
  PRODUCT: 'product',
};

export const BENEFITS_DESCRIPTION = {
  remote: "Get free 'round-the-clock' support for computers, printers, and more.",
  malwarebytes: "We've partnered with MalwareBytes to offer the best in protection against computer threats.",
  dashlane: 'Manage passwords securely, effortlessly, and across all devices with Dashlane.',
  homeTechCheckup: "Exclusive to members, we'll come to your home to evaluate and improve your home tech's security, reliability, and speed.",
  homeTechSpecialist: 'Unlimited, instant help with any connected device. No appointments needed.',
  inHomeServices: 'Save up to $100 with a members-only discount for any in-home service.',
  productDiscount: (discount: string | number) => `Save ${discount}% on curated smart home products, with or without installation.`,
};

export const SERVICES = {
  malwarebytes: {
    name: 'Premium Antivirus Software',
    mobileName: 'Premium Antivirus Software',
    description: BENEFITS_DESCRIPTION.malwarebytes,
  },
  dashlane: {
    name: 'Premium Password Manager',
    mobileName: 'Premium Password Manager',
    description: BENEFITS_DESCRIPTION.dashlane,
  },
  google: {
    name: 'Google Home Mini',
    mobileName: 'Google Home Mini',
    description: '',
  },
};

export const REMOTE = {
  value: 100,
  valueFormatted: '$100',
};

export const REMOTE_SUPPORT_HEADER = 'Includes Remote Computer Support and Remote Printer Setup. Discounts on other remote services.';

//  HTH plan benfits for membership page
const defaultBadge = 'membership exclusive';
export const SMART_HOME_BENEFITS_DETAILS = {
  homeTech: {
    id: PLAN_BENEFITS_IDS.HOME_TECH,
    header: 'Home Tech Specialist',
    alternateHeader: 'Home Tech Specialist',
    subheader: BENEFITS_DESCRIPTION.homeTechSpecialist,
    badgeCopy: 'save up to $100',
    icon: ICON_BENEFITS_REFERENCES.support,
  },
  online: {
    id: PLAN_BENEFITS_IDS.ONLINE,
    header: REMOTE_SUPPORT_HEADER,
    subheader: BENEFITS_DESCRIPTION.remote,
    badgeCopy: 'save up to $100',
    icon: ICON_BENEFITS_REFERENCES.unlimitedSupport,
    value: '$100',
  },
  inHome: (truckRollFee?: number) => ({
    id: PLAN_BENEFITS_IDS.IN_HOME,
    header: `Only $${truckRollFee} for In-Home Services`,
    subheader: BENEFITS_DESCRIPTION.inHomeServices,
    badgeCopy: defaultBadge,
    icon: ICON_BENEFITS_REFERENCES.discounts,
  }),
  ...(HIDE_PRODUCT_CONNECTED_HOME
    ? {}
    : {
        productDiscount: (discount = '10') => ({
          id: PLAN_BENEFITS_IDS.PRODUCT,
          header: `${discount}% Savings on Products`,
          subheader: BENEFITS_DESCRIPTION.productDiscount(discount),
          badgeCopy: defaultBadge,
          icon: ICON_BENEFITS_REFERENCES.productDiscount,
        }),
      }),
  checkup: {
    id: PLAN_BENEFITS_IDS.CHECKUP,
    header: 'Home Technology Checkup',
    subheader: BENEFITS_DESCRIPTION.homeTechCheckup,
    badgeCopy: 'valued at $100',
    icon: ICON_BENEFITS_REFERENCES.homeCheckup,
    value: '$100',
  },
  antivirus: {
    id: PLAN_BENEFITS_IDS.ANTIVIRUS,
    header: 'Premium Antivirus Software',
    subheader: BENEFITS_DESCRIPTION.malwarebytes,
    badgeCopy: 'valued at $40',
    icon: ICON_BENEFITS_REFERENCES.antivirus,
    value: '$40',
  },
  password: {
    id: PLAN_BENEFITS_IDS.PASSWORD,
    header: 'Premium Password Manager',
    subheader: BENEFITS_DESCRIPTION.dashlane,
    badgeCopy: 'valued at $60',
    icon: ICON_BENEFITS_REFERENCES.password,
    value: '$60',
  },
};

// online plan benefits for membership page
export const ONLINE_DETAILS = {
  homeTech: SMART_HOME_BENEFITS_DETAILS.homeTech,
  online: SMART_HOME_BENEFITS_DETAILS.online,
};

// HT Lite plan benefits for membership page
export const HELLOTECH_LITE_DETAILS = {
  online: {
    id: PLAN_BENEFITS_IDS.ONLINE,
    header: REMOTE_SUPPORT_HEADER,
    subheader: '',
    badgeCopy: '',
  },
};

export const UPSELL_MODULE_BENEFITS_DETAILS = {
  homeTech: {
    id: PLAN_BENEFITS_IDS.HOME_TECH,
    header: 'Unlimited Remote Support',
    subheader: 'Instant access to a home tech specialist. No appointments needed',
    icon: ICON_BENEFITS_REFERENCES.support,
  },
  inHome: {
    id: PLAN_BENEFITS_IDS.IN_HOME,
    header: 'Exclusive Discounts',
    subheader: 'Members-only discount on in-home services and products, with $0 platform fees.',
    icon: ICON_BENEFITS_REFERENCES.discounts,
  },
  checkup: {
    id: PLAN_BENEFITS_IDS.CHECKUP,
    header: 'Home Technology Checkup',
    subheader: 'A comprehensive evaluation of your home technology ecosystem',
    icon: ICON_BENEFITS_REFERENCES.homeCheckup,
  },
  antivirus: {
    id: PLAN_BENEFITS_IDS.ANTIVIRUS,
    header: 'Premium Antivirus Software',
    subheader: 'We offer the best in protection against computer threats',
    icon: ICON_BENEFITS_REFERENCES.antivirus,
  },
  password: {
    id: PLAN_BENEFITS_IDS.PASSWORD,
    header: 'Premium Password Manager',
    subheader: BENEFITS_DESCRIPTION.dashlane,
    badgeCopy: 'valued at $60',
    icon: ICON_BENEFITS_REFERENCES.password,
  },
  ...(HIDE_PRODUCT_CONNECTED_HOME
    ? {}
    : {
        productDiscount: (discount: string | number) => ({
          id: PLAN_BENEFITS_IDS.PRODUCT,
          header: 'Premium Password Manager',
          subheader: BENEFITS_DESCRIPTION.productDiscount(discount),
          icon: ICON_BENEFITS_REFERENCES.productDiscount,
        }),
      }),
};

const ProductBenefit =
  HIDE_PRODUCT_CONNECTED_HOME || typeof SMART_HOME_BENEFITS_DETAILS.productDiscount !== 'function'
    ? {}
    : {
        title: SMART_HOME_BENEFITS_DETAILS.productDiscount().header,
        text: SMART_HOME_BENEFITS_DETAILS.productDiscount().subheader,
        icon: SMART_HOME_BENEFITS_DETAILS.productDiscount().icon,
      };

// benefits list for membership page.
export const PLANPAGE_BENEFITS_DETAILS = [
  {
    title: SMART_HOME_BENEFITS_DETAILS.homeTech.header,
    text: SMART_HOME_BENEFITS_DETAILS.homeTech.subheader,
    icon: SMART_HOME_BENEFITS_DETAILS.homeTech.icon,
  },
  {
    title: SMART_HOME_BENEFITS_DETAILS.inHome(69).header,
    text: SMART_HOME_BENEFITS_DETAILS.inHome().subheader,
    icon: SMART_HOME_BENEFITS_DETAILS.inHome().icon,
  },
  { ...ProductBenefit },
  {
    title: SMART_HOME_BENEFITS_DETAILS.online.header,
    text: SMART_HOME_BENEFITS_DETAILS.online.subheader,
    icon: SMART_HOME_BENEFITS_DETAILS.online.icon,
  },
  {
    title: SMART_HOME_BENEFITS_DETAILS.checkup.header,
    text: SMART_HOME_BENEFITS_DETAILS.checkup.subheader,
    icon: SMART_HOME_BENEFITS_DETAILS.checkup.icon,
  },
  {
    title: SMART_HOME_BENEFITS_DETAILS.antivirus.header,
    text: SMART_HOME_BENEFITS_DETAILS.antivirus.subheader,
    icon: SMART_HOME_BENEFITS_DETAILS.antivirus.icon,
  },
  {
    title: SMART_HOME_BENEFITS_DETAILS.password.header,
    text: SMART_HOME_BENEFITS_DETAILS.password.subheader,
    icon: SMART_HOME_BENEFITS_DETAILS.password.icon,
  },
];

/*
  These are hard coded benefits that are rendered based on what the plan's included skus offer.

  USAGE:

  Where these are being used in the codebase:
  SMART_HOME_BENEFITS_DETAILS: src/components/Plans/Pricing/product.zipcodentry.utils.ts and src/components/Sections/EverythingYouGetBlock/addsku.addskucustom.zipcodeentry.constants.ts
  ONLINE_DETAILS: src/components/Plans/Pricing/product.zipcodentry.utils.ts
  BENEFITS_DESCRIPTION, SERVICES, REMOTE: src/components/SubscriptionBenefitsBreakdown/utils/upsellPlanItem
  UPSELL_MODULE_BENEFITS_DETAILS: src/components/HTKit/Modals/MembershipUpsellModal/product.zipcodentry.utils.ts
                                  This is specifically for the new upsell module. There will be a ticket to move the benefits to
                                  split or other CMS tool as product wants control over these.

  In the app:
  cart page line items (when plan is in cart)
  cart page remove plan modal
  upsell cart
  upsell Modal in services page
  field sales upsell plan modal
*/
